var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "noselect"
  }, [_c('handlers-wrapper-button', {
    attrs: {
      "handlers": _vm.getHandlers()
    }
  }), _c('mortgage-applications-approval-wrapper', {
    attrs: {
      "applications-objects": _vm.mortgage.applications
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }